@if(templateForPermitForm){
  <div style="display: flex; align-items: start; justify-content: start;">
    <label [for]="for" class="text-label mb-0">
      <wm-common-text
        [data]="{
          text: entity.label,
          fontFamily: 'roboto'
        }"
        class="sub-header"
        >

      </wm-common-text>

      @if (entity.isRequired && !displayOnly) {
        <wm-common-text
          [data]="{
            text: '*'
          }"
          class="required-asterisk">
        </wm-common-text>
      }
    </label>
    @if (entity.instructions) {
      <!-- <wm-common-button
        [data]="{ text: 'info', variant: 'icon' }"
      ></wm-common-button> -->
      <wm-help-text
      class="ml-1"
        *ngIf="entity.instructions"
        placement="right"
        [helpText]="entity.instructions"
      ></wm-help-text>
    }
  </div>
}@else{
  <div>
    <label [for]="for" class="text-label mb-0">
      {{ entity.label }}
      <span *ngIf="entity.isRequired && !displayOnly" class="text-red">*</span>
    </label>

    <wm-help-text
      class="ml-1"
      *ngIf="entity.instructions"
      placement="right"
      [helpText]="entity.instructions"
    ></wm-help-text>
  </div>
}
